
export default {
  data() {
    return {
      activeSlide: 0,
      inView: false,
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        // autoplay: true,
        navigation: {
          nextEl: ".swiper-testimonials-next",
          prevEl: ".swiper-testimonials-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
        },
      },

      options: [
        {
          name: "title",
          label: "Title",
          type: "text",
        },
        {
          name: "description",
          label: "Description",
          type: "tipTap",
        },
        {
          name: "name",
          label: "Name",
          type: "text",
        },
        {
          name: "position",
          label: "Position",
          type: "text",
        },
        {
          name: "image",
          label: "Image",
          type: "image",
        },
      ],
    };
  },
  //   computed: {
  //     swiper() {
  //       return this.$refs.mySwiper.swiper;
  //     },
  //     swiperThumb() {
  //       return this.$refs.mySwiperThumb.swiper;
  //     },
  //   },
  mounted() {
    // this.activeSlide = this.$refs.mySwiper.mySwiper.activeIndex;
  },
  methods: {
    goToSlide(slide) {
      this.activeSlide = slide;
      //   this.$refs.mySwiper.swiper.slideTo(slide, 0);
    },
    // onSwipe(slide) {
    //   this.activeSlide = this.swiper.activeIndex;
    //   this.$refs.mySwiperThumb.swiper.slideTo(this.swiper.activeIndex, 0);
    // },
  },
};
